import React from "react";

const Checkbox = props => {
  const { input, text, changeValue, meta: { touched, error } } = props;
  return (
    <div>
      <div onClick={() => changeValue(input.name, !input.value)}>
        <input {...input} type="checkbox" checked={input.value} id="checkbox" />
        <label htmlFor="checkbox">{" "}{text}</label>
      </div>
      {touched && error && <span className="invalid">{error}</span>}
    </div>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/form/Checkbox.js